import React from 'react';

import { SavedReplyFragment, SavedReplyInput } from '$/GraphQL/schema/types';

interface SavedRepliesContextValue {
  savedReplies: SavedReplyFragment[];

  onAdd: (defaultValues?: Partial<SavedReplyInput>) => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

export const SavedRepliesContext = React.createContext<SavedRepliesContextValue | undefined>(
  undefined
);

export const useSavedRepliesContext = (): SavedRepliesContextValue => {
  const context = React.useContext(SavedRepliesContext);
  if (!context) {
    throw new Error('useSavedRepliesContext must be used within a SavedRepliesProvider');
  }
  return context;
};

export const useNullableSavedRepliesContext = (): SavedRepliesContextValue | undefined => {
  return React.useContext(SavedRepliesContext);
};
